import { PlusLoadModalActions } from './PlusLoadModal.reducer'

export const createActionOpenPlusLoadModal = () => ({ type: PlusLoadModalActions.OPEN_PLUS_LOAD_MODAL })

const PlusLoadModalActionCreatorsMapping = {
  openPlusLoadModal: () => ({ type: PlusLoadModalActions.OPEN_PLUS_LOAD_MODAL }),
  closePlusLoadModal: () => ({ type: PlusLoadModalActions.CLOSE_PLUS_LOAD_MODAL }),
}

export default PlusLoadModalActionCreatorsMapping
